/* eslint-disable no-undef */
import { graphql, useStaticQuery } from "gatsby"
import { useLocation } from "@reach/router"

let webpsupport

// NEW

export const getRoutesArray = (query, lang) => {
  const routes = query[lang.toLowerCase()]
    ? query[lang.toLowerCase()].navigation
    : null

  if (!routes) return null

  const _routes = Object.keys(routes).map(k => routes[k])

  return _routes
}

// ...

export const isWebpSupported = () => {
  if (typeof webpsupport !== "undefined") return webpsupport

  const elem =
    typeof document === "object" ? document.createElement("canvas") : {}

  webpsupport = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0

  return webpsupport
}

export const isBrowser = () => typeof window !== "undefined"

export const getLangFromPath = () => {
  const { pathname } = useLocation()
  const diffLanguages = ["en", "lt"]
  let result = "PL"

  pathname &&
    pathname.split("/").forEach(el => {
      const lang = diffLanguages.find(language => language === el)
      if (lang) result = lang.toUpperCase()
    })

  return result
}

export const getContent = (query, tag) => {
  const tagArray = tag.toLowerCase().split("_")
  return tagArray
}

export const getRoutesQuery = () => {
  const query = useStaticQuery(graphql`
    {
      chapter {
        pl {
          navigation {
            chapter1 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter2 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter3 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter4 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter5 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter6 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter7 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter8 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter9 {
              name {
                content
              }
              route {
                content
              }
            }
          }
        }
        en {
          navigation {
            chapter1 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter2 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter3 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter4 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter5 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter6 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter7 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter8 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter9 {
              name {
                content
              }
              route {
                content
              }
            }
          }
        }
        lt {
          navigation {
            chapter1 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter2 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter3 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter4 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter5 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter6 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter7 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter8 {
              name {
                content
              }
              route {
                content
              }
            }
            chapter9 {
              name {
                content
              }
              route {
                content
              }
            }
          }
        }
      }
    }
  `)

  return query
}

// EN: mdx(
//   frontmatter: {
//     language: { eq: "EN" }
//     title: { eq: "routes-navigation" }
//   }
// ) {
//   exports {
//     routes {
//       name
//       route
//     }
//   }
// }
